import React from 'react';
import PropTypes from 'prop-types';
import { DATETIME_FORMAT_DATE } from '../../../../../utils/helpers/CommonHelper';
import { DatePicker } from 'antd';

import 'dayjs/locale/sk';
import locale from 'antd/es/date-picker/locale/sk_SK';
import dayjs from 'dayjs';

const SimpleDatePicker = ({ value, onChange, classes, ...rest }) => {
  return (
    <DatePicker
      defaultValue={dayjs(value)}
      onChange={(newDate) => {
        onChange(newDate);
      }}
      placeholder={` - `}
      format={DATETIME_FORMAT_DATE}
      locale={locale}
      size="large"
      style={{ width: '100%' }}
    />
  );
};

SimpleDatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  classes: PropTypes.array,
};

export default SimpleDatePicker;
